import { z } from 'zod';

/** UUID (v7 for ids Ticketing mints; any version accepted on input). */
export const Id = z.uuid();
export type Id = z.infer<typeof Id>;

/** BRE-Auth subject. Opaque: current accounts are UUIDs, legacy rows may not be. */
export const BreAuthSub = z.string().min(1).max(128);
export type BreAuthSub = z.infer<typeof BreAuthSub>;

/** Integer cents. Signed unless a narrower schema is used. */
export const Cents = z.int().min(Number.MIN_SAFE_INTEGER).max(Number.MAX_SAFE_INTEGER);
export const NonNegativeCents = Cents.min(0);
export const PositiveCents = Cents.min(1);

export const BasisPoints = z.int().min(0).max(10_000);

/** 'YYYY-MM-DDTHH:MM:SS.sssZ' — the only timestamp shape stored or exchanged. */
export const Timestamp = z.iso.datetime({ precision: 3 });
export type Timestamp = z.infer<typeof Timestamp>;

/** 'YYYY-MM-DD' in the venue's timezone. */
export const BusinessDate = z.iso.date();
export type BusinessDate = z.infer<typeof BusinessDate>;

/** Client-supplied idempotency key for every financial or inventory mutation. */
export const IdempotencyKey = z.string().min(16).max(128);
